import React from "react";
import {
  Container,
  QuestionTextContainer,
  QuestionLabelContainer,
  QuestionLabel,
  Question,
  InfoIconContainer,
  MainContainer,
  AnswerContainer,
  AnswerIconContainer,
  AnswerIcon,
  Answer,
} from "./styles/questionSection";

export default function QuestionSection({ children, ...props }) {
  return <Container {...props}>{children}</Container>;
}

QuestionSection.QuestionTextContainer = function QuestionSectionQuestionTextContainer({
  children,
  ...props
}) {
  return <QuestionTextContainer {...props}>{children}</QuestionTextContainer>;
};

QuestionSection.QuestionLabelContainer = function QuestionSectionQuestionLabelContainer({
  children,
  ...props
}) {
  return <QuestionLabelContainer {...props}>{children}</QuestionLabelContainer>;
};

QuestionSection.QuestionLabel = function QuestionSectionQuestionLabel({
  children,
  ...props
}) {
  return <QuestionLabel {...props}>{children}</QuestionLabel>;
};

QuestionSection.Question = function QuestionSectionQuestion({
  children,
  ...props
}) {
  return <Question {...props}>{children}</Question>;
};

QuestionSection.InfoIconContainer = function QuestionSectionInfoIconContainer({
  children,
  ...props
}) {
  return <InfoIconContainer {...props}>{children}</InfoIconContainer>;
};

QuestionSection.MainContainer = function QuestionSectionMainContainer({
  children,
  ...props
}) {
  return <MainContainer {...props}>{children}</MainContainer>;
};

QuestionSection.AnswerContainer = function QuestionSectionAnswerContainer({
  children,
  ...props
}) {
  return <AnswerContainer {...props}>{children}</AnswerContainer>;
};

QuestionSection.AnswerIconContainer = function QuestionSectionAnswerIconContainer({
  children,
  ...props
}) {
  return <AnswerIconContainer {...props}>{children}</AnswerIconContainer>;
};

QuestionSection.AnswerIcon = function QuestionSectionAnswerIcon({ ...props }) {
  return <AnswerIcon {...props} />;
};

QuestionSection.Answer = function QuestionSectionAnswer({
  children,
  ...props
}) {
  return <Answer {...props}>{children}</Answer>;
};